// extracted by mini-css-extract-plugin
export default {"heading":"DeleteUserFromGuildModal_heading__IoilN"};